import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListTariffCell } from './charge-point-list-tariff.cell';
import { ChargePointListTariffHeader } from './charge-point-list-tariff.header';

export const ChargePointListTariffColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['tariff']
> = {
  enableSorting: false,
  header: ChargePointListTariffHeader,
  cell: ChargePointListTariffCell,
  meta: { maxWidth: '140px' },
};
